import { css } from '@emotion/css';


const disabledStyle = css({
	margin: '2em 0',
	lineHeight: 1.5
});


/*
	Shown in place of a page whose feature is switched off under General on /admin/settings.
	The frontend staff resources page uses it too, so it carries no link to the backend and
	leans on no theme - the frontend and backend themes share no keys.
*/
export function FeatureDisabled(P:{feature:string})
{
	return (
		<div class={disabledStyle}>
			<p>{P.feature} is turned off for this venue.</p>
			<p>It can be turned back on under General on the Settings page.</p>
		</div>
	);
}
